export default __webpack_public_path__ + "static/media/img1.4e008c4c.png";